import { createStore, createEvent } from "effector";
import { mainStoreState } from "./MainStore.consts";
import { MainStoreState } from "./MainStore.types";

// Eventos (ações)
export const setLoading = createEvent<boolean>('setLoading');
export const setError = createEvent<string | false>('setError');

// Store inicial
export const MainStore = createStore<MainStoreState>(mainStoreState)
  .on(setLoading, (store, loading) => ({...store, loading}))
  .on(setError, (store, error) => ({...store, error}))
  .reset();
